import React from 'react';
import parse from 'html-react-parser';
import { replaceSpecial } from './utils';
import { callGTMAnalytics } from '../../helper/analyticsTag';
import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';
import { useRecoilState } from 'recoil';

type WarningMessageProps = {
  message: string;
  colorGround?: string;
};

const WarningMessage: React.FC<WarningMessageProps> = (props) => {
  const [utagData] = useRecoilState(utagObjectAtom);
  if (props.message.includes('</a>')) {
    let arrayText = replaceSpecial(props.message);
    return (
      <div className={`dk-message--attention warning-message-container`}>
        <div className="dk-message__icon"></div>

        <div className="dk-message__content">
          <span className="dk-message__details">
            {parse(arrayText[0])}
            <a
              href="https://forum.digikey.com/"
              id="tech-forum-link"
              target= "_blank"
              rel="noreferrer"
              track-data="ref_page_event=No Results – TechForum"
              onClick={() =>
                callGTMAnalytics(utagData, 'No Results - TechForum')
              }
            >
              {arrayText[1]}{' '}
            </a>
            {parse(arrayText[2])}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={`dk-message--attention warning-message-container`}>
      <div className="dk-message__icon"></div>
      <div className="dk-message__content">
        <span className="dk-message__details">{parse(props.message)}</span>
      </div>
    </div>
  );
};

export default WarningMessage;
